import { Download, X } from 'lucide-react';
import { useState } from 'react';

import { Button } from '~/components/ui/button';
import { useInstallPrompt } from '~/hooks/useInstallPrompt';

/**
 * Displays a non-intrusive banner prompting the user to install the PWA.
 * Only renders when the browser deems the app installable and the user
 * hasn't dismissed or already installed.
 */
export function PwaInstallPrompt() {
  const { isInstallable, install } = useInstallPrompt();
  const [dismissed, setDismissed] = useState(false);

  if (!isInstallable || dismissed) return null;

  return (
    <div
      role="status"
      className="border-border bg-background fixed right-4 bottom-4 z-50 flex max-w-sm items-center gap-3 rounded-lg border p-4 shadow-lg"
    >
      <Download className="text-primary size-5 shrink-0" />
      <div className="flex-1">
        <p className="text-sm font-medium">Install Agentic</p>
        <p className="text-muted-foreground text-xs">
          Add to your home screen for a faster experience.
        </p>
      </div>
      <div className="flex items-center gap-1">
        <Button
          size="sm"
          className="cursor-pointer"
          onClick={() => {
            void install();
          }}
        >
          Install
        </Button>
        <Button
          variant="ghost"
          size="icon"
          className="size-8 cursor-pointer"
          onClick={() => {
            setDismissed(true);
          }}
        >
          <X className="size-4" />
          <span className="sr-only">Dismiss</span>
        </Button>
      </div>
    </div>
  );
}
